import React, { Component } from 'react'
import { Table, Tooltip, Modal, message, Collapse, Form, Select, DatePicker, Button, Radio, Input, Card, Badge } from 'antd'
import NumberFormat from 'react-number-format'
import { connect } from 'dva'
import { Link } from 'dva/router'
import moment from 'moment'
import InfiniteScroll from '@fand/react-infinite-scroll-container';
import Currency from 'react-currency-formatter';
import { all } from '../../services/restApi'
import { getTotal, createPassword } from '../../utils'
import IncomeNew from './incomeNew'
import config from '../../utils/config'
var Icon = require('react-fontawesome');
const _ = require('underscore')

const { Column } = Table;
const confirm = Modal.confirm
const Panel = Collapse.Panel
const FormItem = Form.Item;
const Option = Select.Option;
const MonthPicker = DatePicker.MonthPicker;
const ButtonGroup = Button.Group;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const TextArea = Input.TextArea;

class income extends Component {

	constructor (props) {
        super(props);

        this.state = {
        	query: {},
            hotels: [],
            incomes: [],
            skip: 0,
            limit: 1000
        }

        message.config({top: 110, duration: 4});

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId)  {
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};
        } else {
            if (this.props.location.pathname === '/incomes/cash_funds_requests/cash_funds' || this.props.location.pathname === '/incomes/cash_funds_requests/others')
                window.history.back()
        }

        /*if (localStorage.getItem('hotelConta')) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('hotelConta'))};*/

        if (this.props.params.incomeType === 'cash_funds_trie' || this.props.params.incomeType === 'others_trie' || this.props.params.incomeType === 'payroll_trie') 
            this.state = {...this.state, currentHotel: null};
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        // Consulta los hoteles
        all('Hotel', {limit: 20}).then((resp) => {
            this.setState({
                hotels: resp.results
            });
        })
    }


    /**
    * Se llama antes del render()
    */
    componentWillMount () {
        this.props.dispatch({type:'income/filterSuccess', 
            payload: { incomes: [] }
        });

        this.firstLoad();
    }



    /**
    * Agrupamos: Cada tipo de gastos por fecha de creación
    */
    groupByDate (array, count) {

        let incomesGrouped = _.groupBy(array, function (d) { return moment(d.requestedAt.iso).format('YYYY-MM-DD') });

        Object.keys(incomesGrouped).map((key, index) => {

            let item = {};
            item.requestedAt = {__type: 'Date', iso: key};
            item.isParent =  true;
            item.children =  incomesGrouped[key];
            item.objectId = createPassword();
            item.amount_income_total = getTotal(incomesGrouped[key], 'amount_income');
            item.amount_expense_total = getTotal(incomesGrouped[key], 'amount_expense');
            item.children.map((i) => { i.parentId = item.objectId });

            this.state.incomes.push(item);

            if (index === Object.keys(incomesGrouped).length - 1) {
                let total = getTotal(this.state.incomes, 'amount_income_total') - getTotal(this.state.incomes, 'amount_expense_total')
                this.setState({ currentTotal: total });

                setTimeout(function() {
                    this.props.dispatch({type: 'app/hideLoadingTable'})
                    this.props.dispatch({type:'income/querySuccess', 
                        payload: { incomes: this.state.incomes }
                    });
                }.bind(this), 500);
            }
        });
    }


    /**
    * Primera carga
    */
    firstLoad () {
        let query = {type: this.props.params.incomeType, status: 'requested'};

        if (this.state.currentHotel) {
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId};
        }

        this.setState({query: query});
        this.props.dispatch({type: 'app/showLoadingTable'})

        all('Income', {
            where: query,
            include: 'hotel,expense,createdBy,chargedTo', 
            skip: 0, 
            limit: this.state.limit, 
            count: 1, 
            order: 'requestedAt'
        }).then(resp => {

            this.setState({ skip: this.state.limit, total_items: resp.count });

            if (resp.results.length > 0)
                this.groupByDate(resp.results, resp.count)
            else
                this.props.dispatch({type: 'app/hideLoadingTable'})

        }).catch(e => {
            if (e && e.data) message.error(e.data.error);
            else message.error('Ha ocurrido un error al consultar los registros. Intente más tarde')    
        });
    }


	/**
	* Carga otro bloque de registros
	*/
    loadMore () {
    	if (this.state.skip < this.state.total_items) {

            this.props.dispatch({type: 'app/showLoadingTable'})
            this.setState({ skip: this.state.skip + this.state.limit });

            all('Income', {
                where: this.state.query,
                include: 'hotel,expense,createdBy,chargedTo', 
                skip: this.state.skip, 
                limit: this.props.income.limit, 
                count: 1, 
                order: 'requestedAt'
            }).then(resp => {

                if (resp.results.length > 0)
                    this.groupByDate(resp.results, resp.count)
                else
                    this.props.dispatch({type: 'app/hideLoadingTable'})

            }).catch(e => {
                if (e && e.data) message.error(e.data.error);
                else message.error('Ha ocurrido un error al consultar otros registros. Intente más tarde')    
            });
    	}
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetch (value, callback) {
        setTimeout(() => {
            all('Hotel', {where: {name: {$regex: '(?i)' + value}}}).then((d) => {
                const results = d.results;
                const hotels = [];
                
                results.forEach((r) => {
                    hotels.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(hotels);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        if (value && value.key && !value.label) {
            this.fetch(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }
    }


    /**
    * Validator: Checa que el monto sea mayor a 0
    */
    checkAmount (rule, value, callback) {
        if (value && !_.isNumber(value) && Number(value.replace(/[^\d.-]/g, '')) === 0) {
            callback('Por favor, ingrese un monto correcto!');
        } else {
            callback();
        }
    } 


    /**
    * Elimina un registro
    */
    delete_item (item) {
        let dispatch = this.props.dispatch;
        let currentTotal = this.state.currentTotal;
        let currentState = this;

        confirm({
            title: '¿Estás seguro que deseas eliminar el registro?',
            onOk () {
                let total = item.amount_income - item.amount_expense;
                currentState.setState({ currentTotal: currentTotal - total });
                dispatch({type: 'income/removeItem', payload: item});
            }
        })
    }


    /**
    * Actualiza el registro como gasto pagado
    */
    aproveIncome (item) {

        // Model
        let data = {};
        data.objectId = item.objectId;
        data.type = this.props.params.incomeType;
        //data.status = 'paidout';
        data.status = 'pending';
        data.parentId = item.parentId;

        this.props.dispatch({type: 'income/update', payload: data});

        /*let dispatch = this.props.dispatch;
        let chargedTo = '';

        this.props.params.incomeType === 'cash_funds' ? chargedTo = 'al Hotel' : chargedTo = 'a Pagos Luis';

        confirm({
            title: 'Está apunto de aprobar este movimiento',
            content: 'Al aprobarlo usted asume que ha realizado el pago y se visualizará en caja',
            onOk () {
                dispatch({type: 'income/update', payload: data});
            }
        });*/
    }


    /**
    * Modales
    */
    showModalNotes (item) { this.setState({ showModalNotes: true, currentIncome: item }); }


  	/**
    * Render del componente
    */
    render () {
    	const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

	    return (
	        <div className="content-wrapper">
	            <section className="content-header">
	            	<h1>
                        <Link onClick={() => window.history.back() }><i className="fa fa-arrow-circle-left"></i></Link>
                        Solicitudes
                    </h1>
	            </section>

	            <section className="content">
	                <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
	                    <div className="box-body">
	                        <div className="row">
	                            <div className="col-xs-12">
	                            	<div className="table-responsive table">

		                            	<InfiniteScroll
										    padding={50}
									        throttle={100}
									        onScroll={() => this.loadMore()}>

		                                    <Table 
		                                    	dataSource={this.props.income.incomes} 
		                                    	rowKey="objectId" 
		                                    	size="middle" 
		                                    	loading={this.props.app.loadingTable} 
		                                    	pagination={false}>

		                                    	{<Column title="Fecha" key="requestedAt" width={135} render={(item) => (
		                                        	<span>
                                                        {item.isParent && item.requestedAt ? moment(item.requestedAt.iso).format('DD/MM/YYYY') : ''}
                                                        {!item.isParent && item.status === 'requested' 
                                                            ? <span><Badge status="warning" /><small>Pendiente</small></span>
                                                            : ''
                                                        }
                                                        {!item.isParent && item.status === 'pending' 
                                                            ? <span><Badge status="success" /><small>Aprobado</small></span>
                                                            : ''
                                                        }
                                                    </span>
		                                        )} />}
                                                {!this.state.currentHotel
    		                                      ? <Column title="Hotel" key="hotel" render={(item) => (
    		                                        	<span>{item.hotel ? item.hotel.name : '-'}</span>
    		                                        )} />
                                                    : ''
                                                }
                                                {this.props.app.user && this.props.app.user.type === 'administrador'
                                                  ? <Column title="Creado por" key="createdBy" render={(item) => (
                                                        <span>{item.createdBy ? item.createdBy.name : '-'}</span>
                                                    )} />
                                                    : ''
                                                }
                                                <Column title="Destino" key="user" render={(item) => (
                                                    <span>
                                                        {item.chargedTo === 'caja' ? 'Caja del Hotel' : ''}
                                                        {item.chargedTo === 'propietario' ? 'Efectivo al propietario' : ''}
                                                        {item.chargedTo === 'trie' ? 'Pagos Directos TRIE' : ''}
                                                    </span>
                                                )}/>
		                                        <Column title="Descripción" render={(item) => (
                                                    <span>{item.items ? item.items : ''}</span>
                                                )}/>
		                                        <Column title="Ingreso" key="amount_income" render={(item) => (
                                                    <span>
                                                        {item.isParent
                                                            ? <Currency quantity={item.amount_income_total ? item.amount_income_total : 0} currency="USD" />
                                                            : <span>
                                                                {item.amount_income
                                                                    ? <Currency quantity={item.amount_income} currency="USD" />
                                                                    : '-'
                                                                }
                                                            </span>
                                                        }
                                                    </span>
                                                )}/>
                                                <Column title="Egreso" key="amount_expense" render={(item) => (
                                                    <span>
                                                        {item.isParent
                                                            ? <Currency quantity={item.amount_expense_total ? item.amount_expense_total : 0} currency="USD" />
                                                            : <span>
                                                                {item.amount_expense
                                                                    ? <Currency quantity={item.amount_expense} currency="USD" />
                                                                    : '-'
                                                                }
                                                            </span>
                                                        }
                                                    </span>
                                                )}/>
                                                {/*<Column title="Cargo a" key="chargedTo" className="color-danger text-bold" render={(item) => (
                                                    <span>{item.chargedTo ? item.chargedTo.name : '-'}</span>
                                                )} />*/}
                                                {/*<Column title="Comprobante" render={(item) => (
                                                    <div className="text-center">
                                                        {!item.isParent
                                                            ? <span>{item.voucher ? 'SI' : 'NO'}</span>
                                                            : ''
                                                        }   
                                                    </div>
                                                )}/>*/}
		                                        <Column title="Acciones" key="action" width={170}
                                                    render={(item) => (
                                                        <span className="actions">
                                                            {!item.isParent
                                                                ? <ButtonGroup>
                                                                    {item.notes || item.comments_byChecked
                                                                        ? <Tooltip placement="bottom" title="Ver notas">
                                                                            <Button>
                                                                                <Link onClick={() => { this.showModalNotes(item) }}><Icon name="comment" /></Link>
                                                                            </Button>
                                                                        </Tooltip>
                                                                        : ''
                                                                    }

                                                                    {item.picture
                                                                        ? <Tooltip placement="bottom" title="Ver comprobante">
                                                                            <Button>
                                                                                <a href={config.externalUrl + 'uploads/docs/' + item.picture} target="_blank"><Icon name="paperclip" /></a>
                                                                            </Button>
                                                                        </Tooltip>
                                                                        : ''
                                                                    }

                                                                    {item.status === 'requested'
                                                                        ? <span>
                                                                            <Tooltip placement="bottom" title="Aprobar">
                                                                                <Button>
                                                                                    <Link onClick={() => { this.aproveIncome(item) }}><Icon name="check" /></Link>
                                                                                </Button>
                                                                            </Tooltip>
                                                                        </span>
                                                                        : ''
                                                                    }

                                                                    {/*<Tooltip placement="bottom" title="Eliminar">
                                                                        <Button>
                                                                            <Link onClick={() => { this.delete_item(item) }} className=""><Icon name="trash" /></Link>
                                                                        </Button>
                                                                    </Tooltip>*/}
                                                                </ButtonGroup>
                                                                : ''
                                                            }
                                                        </span>
                                                    )}
                                                />
		                                    </Table>        
			                            </InfiniteScroll>
		                            </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </section>

                <Modal
                    visible={this.state.showModalNotes}
                    title="Notas"
                    onCancel={() => { this.setState({ showModalNotes: false }); }}
                    footer={[]} 
                >
                    {this.state.showModalNotes
                        ? <span>
                            <Card title="Notas generales" className="marginBottom20">
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.state.currentIncome.notes}
                                    </div>
                                </div>
                            </Card>

                            <Card title="Notas al comprobar el movimiento" className="marginBottom20">
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.state.currentIncome.comments_byChecked}
                                    </div>
                                </div>
                            </Card>
                        </span>
                        : ''
                    }
                </Modal>
	        </div>
	    )
	}
}

export default connect(({income, app}) => ({income, app}))(Form.create()(income))


// WEBPACK FOOTER //
// ./src/components/incomes/cashFundsRequests.js